export const JOURNAL_LANGS = [
  { code: "nl", flag: "🇧🇪", label: "Vlaams" },
  { code: "fr", flag: "🇫🇷", label: "Français" },
  { code: "de", flag: "🇩🇪", label: "Deutsch" },
  { code: "en", flag: "🇬🇧", label: "English" },
];

export const LOCALES = { nl: "nl-BE", fr: "fr-BE", de: "de-DE", en: "en-GB" };

const STRINGS = {
  nl: {
    greeting: "Hoi {name}! 👋",
    greetingSub: "Je bent uitgenodigd om dit reisdagboek te volgen. Reageer per dag op de verslagen en foto's — of laat onderaan een algemene reactie achter.",
    identityTitle: "Wie ben jij?",
    identitySub: "Zo weet de reiziger van wie de reacties komen. We onthouden dit op dit toestel — je krijgt hiermee géén e-mails.",
    namePh: "Je naam",
    emailPh: "Je e-mailadres",
    done: "Klaar ✓",
    reactAs: "Je reageert als",
    edit: "wijzig",
    subOnTitle: "Je krijgt e-mail bij nieuwe verslagen & reacties — klik om uit te schrijven",
    subOffTitle: "Mail me bij nieuwe verslagen & reacties",
    fillIdentity: "Vul eerst je naam en e-mailadres in",
    fillIdentityWho: "Vul eerst je naam en e-mail in bij 'Wie ben jij?'",
    subPending: "Bijna klaar! Check je mailbox en bevestig je inschrijving 📬",
    subUnsubbed: "Uitgeschreven — je krijgt geen mails meer",
    subSubbed: "Top! Je krijgt voortaan een mailtje bij nieuwe verslagen en reacties 📬",
    commentPosted: "Je reactie staat erbij!",
    logTitle: "Reislog — dag per dag",
    newestFirst: "nieuwste eerst",
    noEntries: "Nog geen berichten — de reis moet nog beginnen!",
    stayIn: "Verblijf in {place}",
    otherMoments: "Overige momenten",
    day: "Dag",
    readMore: "Lees het hele verhaal",
    readMoreN: "Lees het hele verhaal ({n} dagen)",
    showLess: "Toon minder",
    generalTitle: "Algemene reactie op de reis",
    feedbackPh: "bv. 'Wat een prachtige foto's! Geniet ervan daar.'",
    speakBtn: "Spreek een reactie in",
    send: "Verstuur",
    sending: "Versturen...",
    feedbackSent: "Je reactie is verstuurd!",
    voiceSent: "Je spraakbericht is omgezet en verstuurd!",
    generalList: "Algemene reacties",
    footer: "Gemaakt met VoltRoute — plan je eigen elektrische roadtrip",
    linkDeadTitle: "Deze link werkt niet meer",
    linkDeadBody: "De uitnodiging is mogelijk ingetrokken door de eigenaar.",
    planOwn: "Plan je eigen trip",
    translating: "Vertalen…",
    translateFail: "Vertalen lukte even niet — probeer het zo opnieuw",
    entryCommentsPh: "Reageer op dit moment...",
    commentHint: "Vul hierboven je naam en e-mail in om te reageren.",
    dayCommentsLabel: "Reacties op deze dag",
    comments: "Reacties",
    photoRetry: "Foto opnieuw laden",
    viewStory: "Verslag",
    viewPhotos: "Foto's",
    slideshow: "Diavoorstelling",
    noPhotos: "Nog geen foto's in dit verslag.",
    photosWord: "foto's",
    react: "Reageer",
    replyTo: "Antwoord aan",
    replyTitle: "Beantwoorden",
    traveler: "reiziger",
    sendComment: "Reactie versturen",
    emojiTip: "Reageer met emoji",
    hourSuffix: "u",
    mapBigger: "Kaart vergroten",
    mapSmaller: "Kaart verkleinen",
    nowDriving: "Nu onderweg",
    onderwegSignal: "Onderweg — laatste signaal om {time}",
    still: "nog",
    arrival: "aankomst ±",
    at: "bij",
    livePosition: "Live positie",
    lastUpdate: "laatste update {time}",
    lastSignal: "laatste signaal {time}",
    plannedPos: "Positie volgens planning",
    expected: "verwacht ±",
    inWord: "in",
    noGpsToday: "nog geen live GPS-signaal vandaag",
    departed: "Ze zijn vertrokken!",
    nowLiveSeen: "Nu live onderweg · laatst gezien {time}",
    followMap: "Volg op de kaart",
    follow: "Volg",
    drivingToast: "Ze rijden nu! Volg de rit live op de kaart",
    routeProgress: "Routevoortgang",
    tripDone: "Reis voltooid 🎉",
    ofDriven: "van {km} km gereden",
    rowDay: "Dag",
    rowDrive: "Rijtijd",
    rowStops: "Laadstops",
    co2Tip: "CO₂ bespaard t.o.v. een benzineauto (±170 g/km)",
    expectedAround: "Verwacht rond ~{time}",
    inPlace: " in {place}",
    sugTitle: "Suggesties voor de reis",
    sugPropose: "Stel zelf iets voor",
    sugIntro: "Ken je een leuke plek, restaurant of mooiere route? De reizigers krijgen een mailtje van je idee.",
    kind_plaats: "Plaats",
    kind_route: "Route",
    kind_restaurant: "Restaurant",
    kind_verblijf: "Verblijf",
    kind_activiteit: "Activiteit",
    kind_anders: "Anders",
    st_nieuw: "Nieuw",
    st_bekeken: "Bekeken",
    st_toegevoegd: "Toegevoegd aan de planning",
    st_afgewezen: "Niet gepland",
    sugTitlePh: "bv. 'Restaurant Le Jardin in Reims'",
    sugTextPh: "Waarom is dit een aanrader? (optioneel)",
    wholeTrip: "Hele reis",
    sugSend: "Stuur suggestie",
    sugThanks: "Bedankt! Je suggestie is doorgestuurd naar de reizigers 💡",
    ownersReply: "Reactie van de reizigers:",
    sugHint: "Vul hierboven je naam en e-mail in om een suggestie te sturen.",
    forDay: "dag",
    sharedTrip: "Gedeelde trip",
    back: "terug",
    lastSeen: "laatst gezien {time}",
    dayOnRoad: "dag {n} onderweg",
    co2Saved: "CO₂ bespaard",
    co2ShareTip: "T.o.v. dezelfde reis met een benzineauto (±170 g CO₂/km)",
    shareNotFoundTitle: "Gedeelde trip niet gevonden",
    shareNotFoundBody: "De link is mogelijk ongeldig of ingetrokken.",
    subExplain: "Alleen wie dit aanzet (en bevestigt via de mail) krijgt e-mails. Zonder e-mail kun je de reis altijd zelf blijven volgen via deze link.",
    depart: "Vertrek",
    homeWord: "Thuis",
    arrivalWord: "Aankomst",
    drivenAlready: "Al gereden",
    outboundLeg: "Heenreis",
    returnLeg: "Terugreis",
    chargePower: "Laadvermogen:",
    hoverDayInfo: "Beweeg over de route voor daginfo",
    startPoint: "Vertrekpunt",
    endPoint: "Eindpunt",
    avoidZone: "Vermeden zone",
    realDriven: "Echt gereden (GPS)",
    nightWord: "nacht",
    nightsWord: "nachten",
    tonightWord: "vannacht",
    storyHeader: "AI-reisverslag",
    familyReactions: "Reacties van familie & vrienden",
    expandAll: "Alles uitklappen",
    collapseAll: "Alles inklappen",
    noLogYet: "Nog geen reislog voor deze trip.",
    momentSing: "moment",
    momentPlur: "momenten",
    reactSing: "reactie",
    reactPlur: "reacties",
  },
  fr: {
    greeting: "Salut {name} ! 👋",
    greetingSub: "Tu es invité(e) à suivre ce carnet de voyage. Réagis jour par jour aux récits et photos — ou laisse une réaction générale en bas.",
    identityTitle: "Qui es-tu ?",
    identitySub: "Ainsi les voyageurs savent de qui viennent les réactions. Nous le mémorisons sur cet appareil — tu ne recevras aucun e-mail pour autant.",
    namePh: "Ton nom",
    emailPh: "Ton adresse e-mail",
    done: "Terminé ✓",
    reactAs: "Tu réagis en tant que",
    edit: "modifier",
    subOnTitle: "Tu reçois un e-mail à chaque nouveau récit & réaction — clique pour te désinscrire",
    subOffTitle: "Préviens-moi par e-mail des nouveaux récits & réactions",
    fillIdentity: "Renseigne d'abord ton nom et ton adresse e-mail",
    fillIdentityWho: "Renseigne d'abord ton nom et ton e-mail dans « Qui es-tu ? »",
    subPending: "Presque fini ! Vérifie ta boîte mail et confirme ton inscription 📬",
    subUnsubbed: "Désinscrit — tu ne recevras plus d'e-mails",
    subSubbed: "Super ! Tu recevras désormais un e-mail à chaque nouveau récit et réaction 📬",
    commentPosted: "Ta réaction a été ajoutée !",
    logTitle: "Journal de voyage — jour par jour",
    newestFirst: "le plus récent d'abord",
    noEntries: "Pas encore de messages — le voyage n'a pas encore commencé !",
    stayIn: "Séjour à {place}",
    otherMoments: "Autres moments",
    day: "Jour",
    readMore: "Lire tout le récit",
    readMoreN: "Lire tout le récit ({n} jours)",
    showLess: "Afficher moins",
    generalTitle: "Réaction générale sur le voyage",
    feedbackPh: "p.ex. « Quelles photos magnifiques ! Profitez-en bien. »",
    speakBtn: "Enregistrer une réaction vocale",
    send: "Envoyer",
    sending: "Envoi...",
    feedbackSent: "Ta réaction a été envoyée !",
    voiceSent: "Ton message vocal a été transcrit et envoyé !",
    generalList: "Réactions générales",
    footer: "Créé avec VoltRoute — planifie ton propre road trip électrique",
    linkDeadTitle: "Ce lien ne fonctionne plus",
    linkDeadBody: "L'invitation a peut-être été révoquée par le propriétaire.",
    planOwn: "Planifie ton propre voyage",
    translating: "Traduction…",
    translateFail: "La traduction a échoué — réessaie dans un instant",
    entryCommentsPh: "Réagis à ce moment...",
    commentHint: "Renseigne ton nom et ton e-mail ci-dessus pour réagir.",
    dayCommentsLabel: "Réactions sur cette journée",
    comments: "Réactions",
    photoRetry: "Recharger la photo",
    viewStory: "Récit",
    viewPhotos: "Photos",
    slideshow: "Diaporama",
    noPhotos: "Pas encore de photos dans ce carnet.",
    photosWord: "photos",
    react: "Réagir",
    replyTo: "Répondre à",
    replyTitle: "Répondre",
    traveler: "voyageur",
    sendComment: "Envoyer la réaction",
    emojiTip: "Réagir avec un emoji",
    hourSuffix: "h",
    mapBigger: "Agrandir la carte",
    mapSmaller: "Réduire la carte",
    nowDriving: "En route maintenant",
    onderwegSignal: "En route — dernier signal à {time}",
    still: "encore",
    arrival: "arrivée ±",
    at: "à",
    livePosition: "Position en direct",
    lastUpdate: "dernière mise à jour {time}",
    lastSignal: "dernier signal {time}",
    plannedPos: "Position selon le planning",
    expected: "prévu ±",
    inWord: "à",
    noGpsToday: "pas encore de signal GPS en direct aujourd'hui",
    departed: "Ils sont partis !",
    nowLiveSeen: "En route en direct · vu à {time}",
    followMap: "Suivre sur la carte",
    follow: "Suivre",
    drivingToast: "Ils roulent maintenant ! Suis le trajet en direct sur la carte",
    routeProgress: "Progression",
    tripDone: "Voyage terminé 🎉",
    ofDriven: "sur {km} km parcourus",
    rowDay: "Jour",
    rowDrive: "Conduite",
    rowStops: "Recharges",
    co2Tip: "CO₂ économisé par rapport à une voiture essence (±170 g/km)",
    expectedAround: "Arrivée prévue vers ~{time}",
    inPlace: " à {place}",
    sugTitle: "Suggestions pour le voyage",
    sugPropose: "Propose quelque chose",
    sugIntro: "Tu connais un chouette endroit, un restaurant ou une plus belle route ? Les voyageurs recevront ton idée par e-mail.",
    kind_plaats: "Lieu",
    kind_route: "Itinéraire",
    kind_restaurant: "Restaurant",
    kind_verblijf: "Hébergement",
    kind_activiteit: "Activité",
    kind_anders: "Autre",
    st_nieuw: "Nouveau",
    st_bekeken: "Vu",
    st_toegevoegd: "Ajouté au planning",
    st_afgewezen: "Non retenu",
    sugTitlePh: "p.ex. « Restaurant Le Jardin à Reims »",
    sugTextPh: "Pourquoi le recommandes-tu ? (facultatif)",
    wholeTrip: "Tout le voyage",
    sugSend: "Envoyer la suggestion",
    sugThanks: "Merci ! Ta suggestion a été transmise aux voyageurs 💡",
    ownersReply: "Réponse des voyageurs :",
    sugHint: "Renseigne ton nom et ton e-mail ci-dessus pour envoyer une suggestion.",
    forDay: "jour",
    sharedTrip: "Voyage partagé",
    back: "retour",
    lastSeen: "vu à {time}",
    dayOnRoad: "jour {n} en route",
    co2Saved: "CO₂ économisé",
    co2ShareTip: "Par rapport au même trajet en voiture essence (±170 g CO₂/km)",
    shareNotFoundTitle: "Voyage partagé introuvable",
    shareNotFoundBody: "Le lien est peut-être invalide ou révoqué.",
    subExplain: "Seuls ceux qui activent ceci (et confirment via l'e-mail) reçoivent des messages. Sans e-mail, tu peux toujours suivre le voyage via ce lien.",
    depart: "Départ",
    homeWord: "Retour maison",
    arrivalWord: "Arrivée",
    drivenAlready: "Déjà parcouru",
    outboundLeg: "Aller",
    returnLeg: "Retour",
    chargePower: "Puissance de charge :",
    hoverDayInfo: "Survole l'itinéraire pour les infos du jour",
    startPoint: "Point de départ",
    endPoint: "Point d'arrivée",
    avoidZone: "Zone évitée",
    realDriven: "Trajet réel (GPS)",
    nightWord: "nuit",
    nightsWord: "nuits",
    tonightWord: "cette nuit",
    storyHeader: "Récit de voyage IA",
    familyReactions: "Réactions de la famille & des amis",
    expandAll: "Tout déplier",
    collapseAll: "Tout replier",
    noLogYet: "Pas encore de journal pour ce voyage.",
    momentSing: "moment",
    momentPlur: "moments",
    reactSing: "réaction",
    reactPlur: "réactions",
  },
  de: {
    greeting: "Hallo {name}! 👋",
    greetingSub: "Du bist eingeladen, dieses Reisetagebuch zu verfolgen. Reagiere Tag für Tag auf Berichte und Fotos — oder hinterlasse unten eine allgemeine Nachricht.",
    identityTitle: "Wer bist du?",
    identitySub: "So wissen die Reisenden, von wem die Reaktionen kommen. Wir merken uns das auf diesem Gerät — du bekommst dadurch keine E-Mails.",
    namePh: "Dein Name",
    emailPh: "Deine E-Mail-Adresse",
    done: "Fertig ✓",
    reactAs: "Du reagierst als",
    edit: "ändern",
    subOnTitle: "Du bekommst eine E-Mail bei neuen Berichten & Reaktionen — klicke zum Abmelden",
    subOffTitle: "Benachrichtige mich per E-Mail über neue Berichte & Reaktionen",
    fillIdentity: "Gib zuerst deinen Namen und deine E-Mail-Adresse ein",
    fillIdentityWho: "Gib zuerst Name und E-Mail bei „Wer bist du?“ ein",
    subPending: "Fast geschafft! Prüfe dein Postfach und bestätige deine Anmeldung 📬",
    subUnsubbed: "Abgemeldet — du bekommst keine E-Mails mehr",
    subSubbed: "Super! Du bekommst ab jetzt eine E-Mail bei neuen Berichten und Reaktionen 📬",
    commentPosted: "Deine Reaktion wurde hinzugefügt!",
    logTitle: "Reisetagebuch — Tag für Tag",
    newestFirst: "Neueste zuerst",
    noEntries: "Noch keine Nachrichten — die Reise muss erst beginnen!",
    stayIn: "Aufenthalt in {place}",
    otherMoments: "Weitere Momente",
    day: "Tag",
    readMore: "Die ganze Geschichte lesen",
    readMoreN: "Die ganze Geschichte lesen ({n} Tage)",
    showLess: "Weniger anzeigen",
    generalTitle: "Allgemeine Reaktion zur Reise",
    feedbackPh: "z.B. „Was für wunderschöne Fotos! Genießt es dort.“",
    speakBtn: "Sprachnachricht aufnehmen",
    send: "Senden",
    sending: "Wird gesendet...",
    feedbackSent: "Deine Reaktion wurde gesendet!",
    voiceSent: "Deine Sprachnachricht wurde umgewandelt und gesendet!",
    generalList: "Allgemeine Reaktionen",
    footer: "Erstellt mit VoltRoute — plane deinen eigenen elektrischen Roadtrip",
    linkDeadTitle: "Dieser Link funktioniert nicht mehr",
    linkDeadBody: "Die Einladung wurde möglicherweise vom Besitzer zurückgezogen.",
    planOwn: "Plane deine eigene Reise",
    translating: "Übersetzen…",
    translateFail: "Übersetzung gerade nicht möglich — versuche es gleich erneut",
    entryCommentsPh: "Reagiere auf diesen Moment...",
    commentHint: "Gib oben Name und E-Mail ein, um zu reagieren.",
    dayCommentsLabel: "Reaktionen zu diesem Tag",
    comments: "Reaktionen",
    photoRetry: "Foto neu laden",
    viewStory: "Bericht",
    viewPhotos: "Fotos",
    slideshow: "Diashow",
    noPhotos: "Noch keine Fotos im Bericht.",
    photosWord: "Fotos",
    react: "Reagieren",
    replyTo: "Antwort an",
    replyTitle: "Antworten",
    traveler: "Reisende(r)",
    sendComment: "Reaktion senden",
    emojiTip: "Mit Emoji reagieren",
    hourSuffix: "h",
    mapBigger: "Karte vergrößern",
    mapSmaller: "Karte verkleinern",
    nowDriving: "Jetzt unterwegs",
    onderwegSignal: "Unterwegs — letztes Signal um {time}",
    still: "noch",
    arrival: "Ankunft ±",
    at: "bei",
    livePosition: "Live-Position",
    lastUpdate: "letztes Update {time}",
    lastSignal: "letztes Signal {time}",
    plannedPos: "Position laut Planung",
    expected: "erwartet ±",
    inWord: "in",
    noGpsToday: "heute noch kein Live-GPS-Signal",
    departed: "Sie sind losgefahren!",
    nowLiveSeen: "Jetzt live unterwegs · zuletzt gesehen {time}",
    followMap: "Auf der Karte folgen",
    follow: "Folgen",
    drivingToast: "Sie fahren jetzt! Verfolge die Fahrt live auf der Karte",
    routeProgress: "Routenfortschritt",
    tripDone: "Reise abgeschlossen 🎉",
    ofDriven: "von {km} km gefahren",
    rowDay: "Tag",
    rowDrive: "Fahrzeit",
    rowStops: "Ladestopps",
    co2Tip: "CO₂ gespart im Vergleich zu einem Benziner (±170 g/km)",
    expectedAround: "Erwartet gegen ~{time}",
    inPlace: " in {place}",
    sugTitle: "Vorschläge für die Reise",
    sugPropose: "Schlag selbst etwas vor",
    sugIntro: "Kennst du einen schönen Ort, ein Restaurant oder eine schönere Route? Die Reisenden bekommen deine Idee per E-Mail.",
    kind_plaats: "Ort",
    kind_route: "Route",
    kind_restaurant: "Restaurant",
    kind_verblijf: "Unterkunft",
    kind_activiteit: "Aktivität",
    kind_anders: "Sonstiges",
    st_nieuw: "Neu",
    st_bekeken: "Gesehen",
    st_toegevoegd: "Zur Planung hinzugefügt",
    st_afgewezen: "Nicht eingeplant",
    sugTitlePh: "z.B. „Restaurant Le Jardin in Reims“",
    sugTextPh: "Warum ist das ein Tipp? (optional)",
    wholeTrip: "Ganze Reise",
    sugSend: "Vorschlag senden",
    sugThanks: "Danke! Dein Vorschlag wurde an die Reisenden weitergeleitet 💡",
    ownersReply: "Antwort der Reisenden:",
    sugHint: "Gib oben Name und E-Mail ein, um einen Vorschlag zu senden.",
    forDay: "Tag",
    sharedTrip: "Geteilte Reise",
    back: "zurück",
    lastSeen: "zuletzt gesehen {time}",
    dayOnRoad: "Tag {n} unterwegs",
    co2Saved: "CO₂ gespart",
    co2ShareTip: "Im Vergleich zur selben Reise mit einem Benziner (±170 g CO₂/km)",
    shareNotFoundTitle: "Geteilte Reise nicht gefunden",
    shareNotFoundBody: "Der Link ist möglicherweise ungültig oder zurückgezogen.",
    subExplain: "Nur wer dies aktiviert (und per E-Mail bestätigt), erhält E-Mails. Ohne E-Mail kannst du die Reise jederzeit über diesen Link verfolgen.",
    depart: "Abfahrt",
    homeWord: "Zuhause",
    arrivalWord: "Ankunft",
    drivenAlready: "Bereits gefahren",
    outboundLeg: "Hinreise",
    returnLeg: "Rückreise",
    chargePower: "Ladeleistung:",
    hoverDayInfo: "Fahre über die Route für Tagesinfos",
    startPoint: "Startpunkt",
    endPoint: "Endpunkt",
    avoidZone: "Gemiedene Zone",
    realDriven: "Tatsächlich gefahren (GPS)",
    nightWord: "Nacht",
    nightsWord: "Nächte",
    tonightWord: "heute Nacht",
    storyHeader: "KI-Reisebericht",
    familyReactions: "Reaktionen von Familie & Freunden",
    expandAll: "Alles ausklappen",
    collapseAll: "Alles einklappen",
    noLogYet: "Noch kein Reisetagebuch für diese Reise.",
    momentSing: "Moment",
    momentPlur: "Momente",
    reactSing: "Reaktion",
    reactPlur: "Reaktionen",
  },
  en: {
    greeting: "Hi {name}! 👋",
    greetingSub: "You're invited to follow this travel journal. React to the daily reports and photos — or leave a general message at the bottom.",
    identityTitle: "Who are you?",
    identitySub: "This way the travellers know who the reactions are from. We remember this on this device — you won't receive any emails because of it.",
    namePh: "Your name",
    emailPh: "Your email address",
    done: "Done ✓",
    reactAs: "You're reacting as",
    edit: "edit",
    subOnTitle: "You'll get an email for new reports & reactions — click to unsubscribe",
    subOffTitle: "Email me about new reports & reactions",
    fillIdentity: "Please fill in your name and email address first",
    fillIdentityWho: "Fill in your name and email under 'Who are you?' first",
    subPending: "Almost there! Check your inbox and confirm your subscription 📬",
    subUnsubbed: "Unsubscribed — you won't receive any more emails",
    subSubbed: "Great! You'll now get an email for new reports and reactions 📬",
    commentPosted: "Your reaction has been added!",
    logTitle: "Travel log — day by day",
    newestFirst: "newest first",
    noEntries: "No posts yet — the trip hasn't started!",
    stayIn: "Stay in {place}",
    otherMoments: "Other moments",
    day: "Day",
    readMore: "Read the full story",
    readMoreN: "Read the full story ({n} days)",
    showLess: "Show less",
    generalTitle: "General reaction to the trip",
    feedbackPh: "e.g. 'What beautiful photos! Enjoy your time there.'",
    speakBtn: "Record a voice reaction",
    send: "Send",
    sending: "Sending...",
    feedbackSent: "Your reaction has been sent!",
    voiceSent: "Your voice message has been transcribed and sent!",
    generalList: "General reactions",
    footer: "Made with VoltRoute — plan your own electric road trip",
    linkDeadTitle: "This link no longer works",
    linkDeadBody: "The invitation may have been revoked by the owner.",
    planOwn: "Plan your own trip",
    translating: "Translating…",
    translateFail: "Translation failed — please try again in a moment",
    entryCommentsPh: "React to this moment...",
    commentHint: "Fill in your name and email above to react.",
    dayCommentsLabel: "Reactions to this day",
    comments: "Reactions",
    photoRetry: "Reload photo",
    viewStory: "Story",
    viewPhotos: "Photos",
    slideshow: "Slideshow",
    noPhotos: "No photos in this journal yet.",
    photosWord: "photos",
    react: "React",
    replyTo: "Reply to",
    replyTitle: "Reply",
    traveler: "traveller",
    sendComment: "Send reaction",
    emojiTip: "React with an emoji",
    hourSuffix: "h",
    mapBigger: "Enlarge map",
    mapSmaller: "Shrink map",
    nowDriving: "On the road now",
    onderwegSignal: "On the road — last signal at {time}",
    still: "still",
    arrival: "arrival ±",
    at: "near",
    livePosition: "Live position",
    lastUpdate: "last update {time}",
    lastSignal: "last signal {time}",
    plannedPos: "Position based on the plan",
    expected: "expected ±",
    inWord: "in",
    noGpsToday: "no live GPS signal yet today",
    departed: "They're off!",
    nowLiveSeen: "Live on the road · last seen {time}",
    followMap: "Follow on the map",
    follow: "Follow",
    drivingToast: "They're driving now! Follow the ride live on the map",
    routeProgress: "Route progress",
    tripDone: "Trip completed 🎉",
    ofDriven: "of {km} km driven",
    rowDay: "Day",
    rowDrive: "Driving",
    rowStops: "Charges",
    co2Tip: "CO₂ saved compared to a petrol car (±170 g/km)",
    expectedAround: "Expected around ~{time}",
    inPlace: " in {place}",
    sugTitle: "Suggestions for the trip",
    sugPropose: "Suggest something yourself",
    sugIntro: "Know a nice spot, restaurant or a more scenic route? The travellers will get your idea by email.",
    kind_plaats: "Place",
    kind_route: "Route",
    kind_restaurant: "Restaurant",
    kind_verblijf: "Stay",
    kind_activiteit: "Activity",
    kind_anders: "Other",
    st_nieuw: "New",
    st_bekeken: "Seen",
    st_toegevoegd: "Added to the plan",
    st_afgewezen: "Not planned",
    sugTitlePh: "e.g. 'Restaurant Le Jardin in Reims'",
    sugTextPh: "Why do you recommend it? (optional)",
    wholeTrip: "Whole trip",
    sugSend: "Send suggestion",
    sugThanks: "Thanks! Your suggestion has been sent to the travellers 💡",
    ownersReply: "Reply from the travellers:",
    sugHint: "Fill in your name and email above to send a suggestion.",
    forDay: "day",
    sharedTrip: "Shared trip",
    back: "back",
    lastSeen: "last seen {time}",
    dayOnRoad: "day {n} on the road",
    co2Saved: "CO₂ saved",
    co2ShareTip: "Compared to the same trip in a petrol car (±170 g CO₂/km)",
    shareNotFoundTitle: "Shared trip not found",
    shareNotFoundBody: "The link may be invalid or revoked.",
    subExplain: "Only those who turn this on (and confirm via the email) receive messages. Without an email you can always follow the trip through this link.",
    depart: "Departure",
    homeWord: "Home",
    arrivalWord: "Arrival",
    drivenAlready: "Driven so far",
    outboundLeg: "Outbound",
    returnLeg: "Return",
    chargePower: "Charging power:",
    hoverDayInfo: "Hover over the route for day info",
    startPoint: "Starting point",
    endPoint: "End point",
    avoidZone: "Avoided zone",
    realDriven: "Actually driven (GPS)",
    nightWord: "night",
    nightsWord: "nights",
    tonightWord: "tonight",
    storyHeader: "AI travel story",
    familyReactions: "Reactions from family & friends",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    noLogYet: "No travel log for this trip yet.",
    momentSing: "moment",
    momentPlur: "moments",
    reactSing: "reaction",
    reactPlur: "reactions",
  },
};

export const makeT = (lang) => (key, vars) => {
  let s = (STRINGS[lang] && STRINGS[lang][key]) ?? STRINGS.nl[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(v);
  return s;
};

export const tNL = makeT("nl");
